module.exports = __webpack_public_path__ + "static/img/data-value.7d8fd6e9.svg";